import type { RouteObject } from "react-router";

import { ErrorPage } from "@/components/Error/ErrorPage";

import { onboardingFlowRoutes } from "./routes";

// KEEP this in the actual order of the onboarding flow
export const onboardingFlowRoute = [
  {
    path: onboardingFlowRoutes.slides,
    lazy: async () => {
      const { OnboardingSlidesPage } = await import("./pages/slides/OnboardingSlidesPage");

      return { element: <OnboardingSlidesPage /> };
    },
  },
  {
    path: onboardingFlowRoutes.codeOfConduct,
    lazy: async () => {
      const { OnboardingCodeOfConductPage } = await import("./pages/code-of-conduct/OnboardingCodeOfConductPage");

      return { element: <OnboardingCodeOfConductPage /> };
    },
  },
  {
    path: onboardingFlowRoutes.userProfile,
    lazy: async () => {
      const { OnboardingUserProfilePage } = await import("./pages/user-profile/OnboardingUserProfilePage");

      return { element: <OnboardingUserProfilePage /> };
    },
  },
  {
    path: onboardingFlowRoutes.autoTranslationSetting,
    lazy: async () => {
      const { OnboardingAutoTranslationSettingPage } =
        await import("./pages/auto-translation-setting/OnboardingAutoTranslationSettingPage");

      return { element: <OnboardingAutoTranslationSettingPage /> };
    },
  },
  {
    path: onboardingFlowRoutes.groups,
    lazy: async () => {
      const { OnboardingGroupsPage } = await import("./pages/groups/OnboardingGroupsPage");

      return { element: <OnboardingGroupsPage /> };
    },
  },
  {
    path: onboardingFlowRoutes.helpCategories,
    lazy: async () => {
      const { OnboardingHelpCategoriesPage } = await import("./pages/help-categories/OnboardingHelpCategoriesPage");

      return { element: <OnboardingHelpCategoriesPage /> };
    },
  },
  {
    path: onboardingFlowRoutes.joinProjectConnection,
    lazy: async () => {
      const { JoinProjectConnectionPage } = await import("./pages/join-project-connection/JoinProjectConnectionPage");

      return { element: <JoinProjectConnectionPage /> };
    },
  },
  { path: "*", element: <ErrorPage status={404} /> },
] satisfies RouteObject[];
